// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"dc8800b1","232":"b944ff16","613":"7e54ee30","694":"7d09c2eb"}[chunkId] + ".chunk.css";
};